import { render, staticRenderFns } from "./BaseTextareaWithProvider.vue?vue&type=template&id=fc7e58d6&scoped=true&"
import script from "./BaseTextareaWithProvider.vue?vue&type=script&lang=js&"
export * from "./BaseTextareaWithProvider.vue?vue&type=script&lang=js&"
import style0 from "./BaseTextareaWithProvider.vue?vue&type=style&index=0&id=fc7e58d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7e58d6",
  null
  
)

export default component.exports